import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-621affba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center-container" }
const _hoisted_2 = { class: "form_box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "profilePicture" }, "프로필 사진 선택", -1))
const _hoisted_4 = { class: "image-list" }
const _hoisted_5 = ["src", "alt", "onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, "아이디", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nickname" }, "닉네임", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "비밀번호", -1))

import { ref } from 'vue';
import { routeHelper } from '@utils';
import { postSignup } from '@apis/voicechat';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUp',
  setup(__props) {

const userId = ref('');
const userPwd = ref('');
const userName = ref('');
const selectedPicture = ref<string | null>(null);
const { pushPage } = routeHelper;

// 샘플 이미지 목록
const sampleImages = [
  {
    id: 1,
    name: '사진 1',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_fox.png'),
  },
  {
    id: 2,
    name: '사진 2',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_dog.png'),
  },
  {
    id: 3,
    name: '사진 3',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_bear.png'),
  },
  {
    id: 4,
    name: '사진 4',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_unicorn.png'),
  },
  {
    id: 5,
    name: '사진 5',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_tiger.png'),
  },
  {
    id: 6,
    name: '사진 6',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_shark.png'),
  },
  {
    id: 7,
    name: '사진 7',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_koala.png'),
  },
  {
    id: 8,
    name: '사진 8',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_lion.png'),
  },
];

const clearInputs = () => {
  userId.value = '';
  userPwd.value = '';
  userName.value = '';
  selectedPicture.value = null;
};

const selectedFileName = ref('');
const selectPicture = (url: string) => {
  selectedPicture.value = url;
  const fileName = url.split('/').pop();
  const fileNameWithoutHash = fileName.replace(/\.\w+\./, '.');
  selectedFileName.value = fileNameWithoutHash;
};

const requestSignup = async () => {
  // 선택한 이미지의 URL을 회원가입 요청에 추가
  const params = {
    user_id: userId.value,
    nick_name: userName.value,
    pwd: userPwd.value,
    profile: selectedFileName.value,
  };
  try {
    await postSignup(params);
    clearInputs();
    pushPage('login');
  } catch (error) {
    alert(`가입 실패: ${error.message}`);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sampleImages, (sampleImage) => {
          return _createElementVNode("li", {
            key: sampleImage.id
          }, [
            _createElementVNode("img", {
              src: sampleImage.url,
              alt: sampleImage.name,
              class: _normalizeClass({ selected: sampleImage.url === selectedPicture.value }),
              onClick: ($event: any) => (selectPicture(sampleImage.url))
            }, null, 10, _hoisted_5)
          ])
        }), 64))
      ]),
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userId).value = $event)),
        type: "text",
        name: "username",
        required: ""
      }, null, 512), [
        [_vModelText, userId.value]
      ]),
      _hoisted_7,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userName).value = $event)),
        type: "text",
        name: "nickname",
        required: ""
      }, null, 512), [
        [_vModelText, userName.value]
      ]),
      _hoisted_8,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userPwd).value = $event)),
        type: "password",
        name: "password",
        required: ""
      }, null, 512), [
        [_vModelText, userPwd.value]
      ]),
      _createElementVNode("div", { class: "wrap_button" }, [
        _createElementVNode("div", {
          class: "button_okay",
          onClick: requestSignup
        }, " 가입하기 ")
      ])
    ])
  ]))
}
}

})